import request from '@/utils/request'

export function downloadPdf (filename) {
    return request({
      url: '/download_attachment/' + filename,
      method: 'get',
      responseType: 'blob',
    }).then( response => {
  
        var newBlob = new Blob([response], {type: "application/pdf"});
        var fileURL = window.URL.createObjectURL(newBlob, { oneTimeOnly: true });
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);
        fileLink.click();
  
        // let tab = window.open(); 
        // tab.location.href = fileURL;
  
    })
  }